import React from 'react';

import EditorRadioButtonList from './ssEditorRadioButtonList';
import RuntimeRadioButtonList from './ssRuntimeRadioButtonList';
import ViewOnlyDataSourceControl from '../ViewOnlyDataSourceControl';

const SSRadioButtonList = (props) => {
  const { isEditor, isViewOnly, isDetail } = props;

  return isEditor ? (
    <EditorRadioButtonList {...props} />
  ) : isViewOnly || isDetail ? (
    <ViewOnlyDataSourceControl {...props} />
  ) : (
    <RuntimeRadioButtonList {...props} />
  );
};

export default SSRadioButtonList;
